import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { executeRecaptcha } from '@/lib/recaptcha';

export interface ProposalSubmission {
  firstName?: string;
  lastName?: string;
  email: string;
  phone?: string;
  selectedPackage?: 'Basic' | 'Advanced' | 'Custom' | '';
  selectedSolutions: string[];
  companyName: string;
  companyUrl?: string;
  country?: string;
  employees?: string;
  businessModel?: string;
  marketingConsent: boolean;
}

const userAgent = () =>
  typeof navigator !== 'undefined' ? navigator.userAgent.slice(0, 500) : '';

export async function submitProposal(data: ProposalSubmission): Promise<void> {
  const recaptchaToken = await executeRecaptcha('proposal');
  await addDoc(collection(db, 'proposals'), {
    firstName: data.firstName ?? '',
    lastName: data.lastName ?? '',
    email: data.email,
    phone: data.phone ?? '',
    selectedPackage: data.selectedPackage ?? '',
    selectedSolutions: data.selectedSolutions,
    companyName: data.companyName,
    companyUrl: data.companyUrl ?? '',
    country: data.country ?? '',
    employees: data.employees ?? '',
    businessModel: data.businessModel ?? '',
    marketingConsent: data.marketingConsent,
    recaptchaToken: recaptchaToken ?? null,
    createdAt: serverTimestamp(),
    source: 'landing-page',
    userAgent: userAgent(),
  });
}

export async function submitMailingList(email: string): Promise<void> {
  const recaptchaToken = await executeRecaptcha('mailing_list');
  await addDoc(collection(db, 'mailingList'), {
    email,
    recaptchaToken: recaptchaToken ?? null,
    createdAt: serverTimestamp(),
    source: 'footer',
    userAgent: userAgent(),
  });
}

export async function submitEnforcementTracker(email: string): Promise<void> {
  const recaptchaToken = await executeRecaptcha('enforcement_tracker');
  await addDoc(collection(db, 'enforcementTrackerSignups'), {
    email,
    recaptchaToken: recaptchaToken ?? null,
    createdAt: serverTimestamp(),
    source: 'footer',
    userAgent: userAgent(),
  });
}

export async function submitWaitlist(email: string, organisation: string): Promise<void> {
  const recaptchaToken = await executeRecaptcha('waitlist');
  await addDoc(collection(db, 'platformWaitlist'), {
    email,
    organisation,
    recaptchaToken: recaptchaToken ?? null,
    createdAt: serverTimestamp(),
    source: 'platform-section',
    userAgent: userAgent(),
  });
}
